module.exports = __webpack_public_path__ + "static/media/bank-card.965afa17.png";